import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Box, CircularProgress } from '@material-ui/core'
import { makeStyles } from '@material-ui/styles';
import EmazeForm from './EmazeForm'
import { FORM_VIEW } from '../actions/main'
import '../components/App.css'
import { getFormConfig } from '../actions/form';

const loaderCss = makeStyles({
    root:{
        color: '#f5b01b',
        position: 'absolute',
        left: 0,
        top: 0,
        right: 0,
        bottom: 0,
        margin: "auto"
    }
})

const Loader = () => {
    const classes = loaderCss()
    return(
        <CircularProgress classes={{ root: classes.root}} size={70}></CircularProgress>
    )
}

class FormApp extends Component {
    
    componentDidMount() {
        let path = window.location.pathname.replace('/','')
        let params = path.split('/')
        let regExpFormId = new RegExp('^[0-9]+$');
        let regExpPresId = new RegExp('^@[A-Z]+$');
        if(params[0].length > 0 && params[0].match(regExpFormId) !== null && params[1].match(regExpPresId) !== null){
            this.props.init(parseInt(params[0]), params[1])    
        }
    }

    render(){
        switch(this.props.main.view){
            case FORM_VIEW:
              return(
                <Box className="AppForm-container">
                    <EmazeForm isPreview={false}></EmazeForm>
                </Box>
              )            
            default:
              return(
                <Box className="AppForm-container">
                    <Loader></Loader>
                </Box>
              )
          }        
    }
}

const mapStateToProps = state => ({
    ...state
})

const mapDispatchToProps = dispatch => ({
     init: (formId, presId) => dispatch(getFormConfig(formId, presId))
})

export default connect(mapStateToProps, mapDispatchToProps)(FormApp)